/** @file Writes a segment's endpoints into a reused [x0, y0, x1, y1] buffer (no array per segment). */

/** Sets out = [x0, y0, x1, y1] and returns it, ready for emitLine. */
export function fillSegment(out: Float64Array, x0: number, y0: number, x1: number, y1: number): Float64Array {
  out[0] = x0;
  out[1] = y0;
  out[2] = x1;
  out[3] = y1;
  return out;
}
